import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { FormGenerator } from "@kehillahglobal/ui";
import ApiCallHandler from "../../../../shared/js/ApiCallHandler";
import URLS from "../../../../shared/js/urls";
import { updateUserInfoAction } from "../../../../store/actions/actions";
import { withRouter } from 'react-router-dom';
import {emailValidator, phoneNumberValidator,} from "../../../../shared/js/formFieldValidators";


class CreateOrEditUserContacts extends Component {
  constructor(props) {
    super(props);
    this.contactInfoRef = React.createRef();
  }

  componentDidMount() {
    let { onMount } = this.props;
    if (onMount) {
      onMount(() => this.saveDataToDB());
    }
  }

  saveDataToDB = async () => {
    let { user } = this.props;
    const data = this.contactInfoRef.current?.onClickFromOutside();
    let res;
    if (data) {
      data.user = user?.id;
      if (user?.contacts !== null) {
        data.id = user?.contacts?.id;
        res = await ApiCallHandler.send(URLS.UPDATE_CONTACTS, "POST", data);
      } else {
        res = await ApiCallHandler.send(URLS.CREATE_CONTACTS, "POST", data);
      }

      if (res && res?.success) {
    let newUser = user;
     newUser.contacts =user?.contacts !== null ? res?.data[0] : res?.data;
        this.props.updateUserInfo(newUser)
      }
    }
  };
  render() {
    let { user } = this.props;
    let cookUserDefaultEmail = user?.contacts?.secondary_email || user?.email 
    const formData = [
      {
        fieldType: FormGenerator.Fields.INPUT,
        label: "Primary Email",
        name: "primary_email",
        placeholder: "General email or official email",
        required: true,
        value: user?.id ? cookUserDefaultEmail : "",
        validator: (email) => emailValidator(email),
      },
      {
        fieldType: FormGenerator.Fields.INPUT,
        label: "Other Email",
        name: "secondary_email",
        placeholder: "Secondary email",
        value: user?.id ? user?.contacts?.secondary_email : "",
        validator: (email) => emailValidator(email),
      },
      {
        fieldType: FormGenerator.Fields.INPUT,
        label: "Primary Phone Number",
        name: "primary_phone",
        placeholder: "Primary phone number (e.g. +233244445555)",
        required: true,
        value: user?.id ? user?.contacts?.primary_phone : "",
        validator: (phone) => phoneNumberValidator(phone),
      },
      {
        fieldType: FormGenerator.Fields.INPUT,
        label: "Secondary Phone Number",
        name: "secondary_phone",
        placeholder: "Secondary Phone Number (e.g. +233244445555)",
        value: user?.id ? user?.contacts?.secondary_phone : "",
        validator: (phone) => phoneNumberValidator(phone),
      },
    ];

    return (
      <div>
        {" "}
        <FormGenerator
          elevation={0}
          subtitle=""
          title=""
          formSubmitBtnText={"Save Changes"}
          fields={formData}
          hideSubmitBtn={true}
          ref={this.contactInfoRef}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.userData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
      updateUserInfo: updateUserInfoAction
  }, dispatch);
};
export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateOrEditUserContacts));
